export default __webpack_public_path__ + "static/media/Reader's Tunic of the Eternal Eclipse.5b2d6fcb.jpg";